import React, { useState, useEffect, useRef, useMemo } from 'react';
import { translatedMessage } from '../../service/LanguageService';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
import DataTableUtils from '../../utilities/DataTableUtils';
import { CompetitionService } from '../../service/CompetitionService';

const CompetitionEducationListViewComponent = (props) => {
    const [isLoading, setIsLoading] = useState(true);    
    const [educationList, setEducationList] = useState(null);

    const toast = useRef(null);
    const dt = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setIsLoading(true)

        const getEducation = async () => {
            await competitionService.getCompetitionEducationList(props?.competition?.id)
                .then((_edList) => {
                    // console.log("edList: ", _edList);
                    setEducationList(_edList);
                    setIsLoading(false);
                })
                .catch((error) => error && toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getEducation()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    if (isLoading) {
        return (
            <div className='w-full flex align-items-center'>
                <Toast ref={toast}></Toast>
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <div className='col-12 mt-5'>
                    <h5 className='mb-1'>{translatedMessage('competition.requirements.education')}</h5>
                    <DataTable
                        ref={dt}
                        value={educationList}
                        dataKey="id"
                        // paginator
                        rows={DataTableUtils.defalRowsPerPage()}
                        rowsPerPageOptions={DataTableUtils.rowsPerPageOptions()}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate={"{first} - {last} " + translatedMessage('generic.of') + " {totalRecords}"}
                        emptyMessage={translatedMessage("generic.tableEmptyMessage")}
                        responsiveLayout="scroll"
                    >
                        <Column
                            field="isced.label"
                            header={translatedMessage("profile.education.isced")}
                            headerStyle={{ width: '25%', minWidth: '8rem' }}
                            body={(e) => translatedMessage("CompetitionEducation." + e.isced.code)}
                        />
                        <Column
                            field="domainName"
                            header={translatedMessage("profile.education.domain")}
                            headerStyle={{ width: '50%', minWidth: '8rem' }}
                            body={(e) => e.domainName || translatedMessage("education.domain.any")}
                        />
                    </DataTable>
                </div>
            </>
        );
    }
};

export default CompetitionEducationListViewComponent;
